import React from 'react';

const Footer: React.FC = () => (
  <footer className="site-footer">
    <p>© 2026 Jan Guddal · FOR THE BOYS</p>
  </footer>
);

export default Footer;
